import React, { createContext, useContext, useState, useEffect, useRef } from 'react';
import { api } from '../../utils/api';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const loginUser = (userData) => {
    localStorage.setItem('userToken_TOVIAPPS', userData.token);
    setUser({
      token: userData.token,
      username: userData.username,
      email: userData.email,
      permissions: userData.permissions || ['Suporte'], // Default to Suporte if no permissions
      isAdmin: userData.isAdmin || false,
    });
  };

  const logoutUser = () => {
    setUser(null);
    localStorage.removeItem('userToken_TOVIAPPS');
  };

  const hasFetched = useRef(false);

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;

    const validateToken = async () => {
      const token = localStorage.getItem('userToken_TOVIAPPS');
      if (!token) {
        setLoading(false);
        return;
      }

      try {
        // Use our new API utility for token validation
        const response = await api.get('api/webuser/validate');
        
        // If null response, token was invalid and redirect happened in the API utility
        if (!response) {
          setLoading(false);
          return;
        }

        if (!response.ok) {
          throw new Error('Token inválido ou expirado');
        }

        const data = await response.json();

        setUser({
          token,
          username: data.user.username,
          email: data.user.email,
          permissions: data.user.permissions || ['Suporte'],
          isAdmin: data.user.isAdmin || false,
        });
      } catch (err) {
        console.error('Token validation failed:', err.message);
        localStorage.removeItem('userToken_TOVIAPPS');
        setUser(null);
        window.location.href = '/login'; // Force redirect to login
      } finally {
        setLoading(false);
      }
    };

    validateToken();
  }, []);

  if (loading) {
    return <div>Loading...</div>; // You can replace this with Chakra UI Spinner
  }

  return (
    <UserContext.Provider value={{ user, loginUser, logoutUser }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);